
import { axiosNewAjax, axiosAjax } from '@/utils/ajax'
export default class trianClassManageApi{

    //获取培训班列表
    static getTrainClassPage(data){
        return axiosNewAjax('post','/studyapp-service/trainClass/getTrainClassPage',data)
    }

    //获取所有的课程
    static getAllCourse(data){
        return axiosNewAjax('get','/studyapp-service/trainClass/getAllCourse',data)
    }

    //获取年份
    static getTrainYearList(data){
        return axiosNewAjax('post','/studyapp-service/trainClass/getTrainYearList',data)
    }

    //新增培训班
    static addTrainClass(data){
        return axiosNewAjax('post','/studyapp-service/trainClass/addTrainClass',data)
    }

    //编辑培训班
    static editTrainClass(data){
        return axiosNewAjax('post','/studyapp-service/trainClass/editTrainClass',data)
    }
 
    //改变培训班状态：启停和删除
    static setTrainStatus(data){
        return axiosAjax('post','/studyapp-service/trainClass/setTrainStatus',data)
    }

    //教员管理

    //获取教员列表
    static getTeacherList(data){
        return axiosAjax('post','/comuser-service/Account/getAllMemberByDepId',data)
    }

    //新增教员
    static setOrRemoveTeachers(data){
        return axiosAjax('post','/comuser-service/Account/setOrRemoveTeachers',data)
    }
}


// WEBPACK FOOTER //
// ./src/api/trianClassManageApi.js